







import Vue from 'vue'
import Container from './components/Container.vue'

export default Vue.extend({
  components: {
    Container
  }
})
